export const DEFAULT_PERMISSIONS = "permissions/default";
export const GLOBAL_PERMISSIONS = "permissions/globalperms";
export const USERPERM = "permissions/user";
export const SHARECALENDAR = "permissions/calendar/share";
export const SYNCCALENDAR = "permissions/calendar/sync";
